export const SITE_URL = "https://daniel.bruwel.com";

const SEO = [
	{
		page: "home",
		description:
			"I am a mathematician, researcher, and data scientist completing an MPhil in Pure Mathematics at The University of Sydney.",
		keywords: ["Bruwel", "Daniel Bruwel", "Data Science", "Mathematics", "Computational Topology"],
	},

	{
		page: "about",
		description:
			"My work bridges academic research and applied industry problem-solving, with a focus on building mathematical architectures from the ground up.",
		keywords: ["Bruwel", "Daniel Bruwel", "Data Science", "Mathematics", "Applied Mathematics"],
	},

	{
		page: "resume",
		description:
			"Resume covering education, industry experience, research, talks, teaching, and technical skills.",
		keywords: ["Bruwel", "Daniel Bruwel", "Data Science", "Mathematics", "Resume"],
	},

	{
		page: "projects",
		description:
			"A collection of my research projects, both affiliated and unaffiliated, spanning pure mathematics, physics, and applied data science.",
		keywords: ["Bruwel", "Daniel Bruwel", "Data Science", "Mathematics", "Research Projects"],
	},

	{
		page: "articles",
		description:
			"This is a collection of things I've learned or figured out in data science and mathematics that I think might be useful to others in the field.",
		keywords: ["Bruwel", "Daniel Bruwel", "Data Science", "Mathematics", "Articles"],
	},

	{
		page: "contact",
		description:
			"I am always interested in applying my mathematical background to new domains. If you have an unstructured problem, I’d love to hear about it.",
		keywords: ["Bruwel", "Daniel Bruwel", "Data Science", "Mathematics", "Contact"],
	},
];

export default SEO;
